import React from 'react';
import styled from 'styled-components';
import { white } from '@avangard/ui/colors';
import { breakpoints } from '@avangard/ui/utils';

import { useCurrentUser } from '@modules/auth/hooks';
import {
    CompanyIdentifiersFormGroup,
    CompanyResponsiblesFormGroup,
    DocumentFormGroup,
    SchoolCommonInfo,
} from '@modules/schools/moleculas';

const GroupsContainer = styled.div`
    > * {
        background: ${white[100]};
        padding: 32px;
        border-radius: 8px;

        &:not(:last-child) {
            margin-bottom: 24px;
        }

        ${breakpoints.down('xs')} {
            padding: 20px;
        }
    }
`;

const RequisitesEditFormGroup = React.memo((): React.ReactElement => {
    const { currentUser } = useCurrentUser({ fetchPolicy: 'cache-only' });

    return (
        <GroupsContainer>
            <SchoolCommonInfo school={currentUser.school} />
            <CompanyIdentifiersFormGroup />
            <CompanyResponsiblesFormGroup />
            <DocumentFormGroup />
        </GroupsContainer>
    );
});

export { RequisitesEditFormGroup };
